export const LIMIT_CYCLE_MAP = {
  None: 'NO_INTERVAL',
  Daily: 'DAILY',
  Weekly: 'WEEKLY',
  Monthy: 'MONTHLY',
};

export const maxGasErrorMessage = 'Per user maximum cannot exceed global maximum.';
export const maxUserOpGasErrorMessage = 'Per User Operation maximum cannot exceed global maximum';
export const minGasError = 'The maximum amount must be at least 0.01 USD';
export const minUserOpError = 'The maximum amount must be at least 1';

export const PAYMASTER_ERROR_MAP: Record<string, string> = {
  '-32000': 'Internal error',
  '-32001': 'Unauthorized',
  '-32002': 'Request denied',
  '-32003': 'Service unavailable',
  '-32004': 'Gas estimation error',
  '-32601': 'Method not found',
  '-32602': 'Invalid argument',
  '-32700': 'Parse error',
};

export const BUNDLER_ERROR_MAP: Record<string, string> = {
  '-32500': 'Rejected by EP or account',
  '-32501': 'Rejected by Paymaster',
  '-32502': 'Banned opcode',
  '-32503': 'Short deadline',
  '-32504': 'Banned or throttled entity',
  '-32505': 'Invalid entity stake',
  '-32506': 'Invalid aggregator',
  '-32507': 'Invalid signature',
  '-32521': 'Execution reverted',
  '-32602': 'Invalid fields',
};

export const logTypeOptions = [
  { label: 'Paymaster', value: 'paymaster' },
  { label: 'Bundler', value: 'bundler' },
];

export const logTimelineOptions = [
  { label: 'Past 30 min', value: 'min' },
  { label: 'Past hour', value: 'hour' },
  { label: 'Past day', value: 'day' },
  { label: 'All time', value: 'all' },
];
